import Header from './components/Header';
import Hero from './components/Hero';
import TopicsSection from './components/TopicsSection';
import UpdatesSection from './components/UpdatesSection';
import FeaturesSection from './components/FeaturesSection';
import AppSection from './components/AppSection';
import FaqSection from './components/FaqSection';
import CardsSection from './components/CardsSection';
import MediaSection from './components/MediaSection';
import IndexSection from './components/IndexSection';
import ContactSection from './components/ContactSection';
import RankingSection from './components/RankingSection';
import CarouselSection from './components/CarouselSection';
import CommentsSection from './components/CommentsSection';
import AboutSection from './components/AboutSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <TopicsSection />
        <UpdatesSection />
        <FeaturesSection />
        <AppSection />
        <FaqSection />
        <CardsSection />
        <MediaSection />
        <IndexSection />
        <ContactSection />
        <RankingSection />
        <CarouselSection />
        <CommentsSection />
        <AboutSection />
      </main>
      <Footer />
    </>
  );
}